export function parseCodeFromURL(url: string) {
  if (typeof url !== "string") {
    return false;
  }

  if (url.indexOf("/") === -1) {
    return false;
  }
  // Check if there is chance that this is URL
  if (!url || url === null || url.length < 5) {
    return false;
  }

  // In case url will be istkt.com/code
  // pieces would be ["istkt.com","code"]
  // we want always last piece, which should be code.
  const pieces = url.split("/");
  const code = pieces[pieces.length - 1];
  if (code.length !== 5) {
    return false;
  }
  return code;
}



// WEBPACK FOOTER //
// ./src/components/ticket-scanner/methods.ts